// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyAwayAbVJs2Je_Dxj8fpe5IikDjwP_fDiA",
    authDomain: "lechuanhat.firebaseapp.com",
    databaseURL: "https://lechuanhat.firebaseio.com",
    projectId: "lechuanhat",
    storageBucket: "lechuanhat.appspot.com",
    messagingSenderId: "273236643303",
    appId: "1:273236643303:web:f512f183a94170f9254142",
    measurementId: "G-DDX178168H"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
